export const GiraffeHeadsetAvatar = ({ width = "216", height = "216" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 216 216"
    fill="none"
  >
    <mask
      id="giraffe-headset-avatar"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="216"
      height="216"
    >
      <circle cx="108" cy="108" r="108" fill="#FFFFFF" />
    </mask>
    <g mask="url(#giraffe-headset-avatar)">
      <circle cx="108" cy="108" r="108" fill="#E3F7FC" />
      <path
        d="M105 152.3s71.6 233.7 53.7 267C139.2 456 57 448.2 57 448.2l-1.6 36.2S129.8 495 184.1 470l14.7 61.2s-67.2 74.3-49.2 186.1H181s-1.4-132.8 91-158l36.4-9.8s18.5-13.5 12-45.4c-4.7-28-93.7-152.3-93.7-152.3C214.3 334.5 141.1 94 141.1 94l-50 16.3 13.8 41.9z"
        fill="#FFDD06"
      />
      <path
        d="M105.2 22c-1-1.8-2.8-3-4.7-3.3l-2.6-.5a7 7 0 00-5.6 1.6 6.4 6.4 0 00-2.2 5.3l.2 3.3c0 .4 0 .8-.2 1.2l-.4 1c-.6 1.6-1 3-1.4 4.7l-1.2 11.4-9.5-6h-.1c-1.4-.9-3-1.4-4.6-2l-1-.2c-.4-.1-.9-.3-1.2-.8l-2.3-2a6.8 6.8 0 00-5.5-1.7c-2 .3-3.8 1.7-4.7 3.3L57 39.5c-1 1.8-1 3.9-.2 5.8a6.4 6.4 0 004.3 3.7l3.1.8c.4.2.8.3 1.2.7l.8.7c1.3 1 2.6 2 4 2.8l9.8 4a19 19 0 019.2 9.6c.7 1.3 2 4.5 2 4.5l4.2 9 13-6.2-4.6-8.8-2-4.5c-2.3-4.9-2.8-9-1.7-13l2.9-10v-.1c.2-1.7.3-3.3.3-5v-1.4c0-.4 0-.8.3-1.2l1.2-3c1.5-2 1.3-4.1.4-6z"
        fill="#724010"
      />
      <path
        d="M144.1 35.5c-6.8 2.2-13.5 6-17.3 12-3.2 5-5.7 10.7-6 16.6-.7 7.1-1 14.3 0 25.4 0 0 8.6 1.6 8.5 3.7 8.9-2.7 22.9-6.1 28.5-12.9 6-7 7.7-13.7 8.1-23 .7-9.2-2-18.5-2.2-27.8-6.4 1.8-13.7 4-19.6 6z"
        fill="#FFDD06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.5 64.1a19.2 19.2 0 0115.2-1.4c5.1 2 9 5 10.8 11l21.2 73-49.7 14.5-16.6 4.8-.8.2a42.5 42.5 0 01-46.7-16.8l-.2-.3-.1-.2c-9.8-16.4 1.3-35.8 15-48.3a419 419 0 0136.7-28.1c.7-.4 1.2-1 2-1.3l13.2-7z"
        fill="#FFDD06"
      />
      <path
        d="M93.8 102.5a7.3 7.3 0 016-2.2c2 .3 3.6 1.2 4.8 2.5 1.3 1.4 3.7.7 3.6-1.2v-.1c-.3-3.8-3-7-6.6-8.1a9.8 9.8 0 00-12.8 10.5 2 2 0 003.6.8c.2-1 .7-1.5 1.4-2.2z"
        fill="#373A3B"
      />
      <path d="M107.7 160.9s21.3-5.3 32-16.4c0 0-2.8 22.3-28 30.1l-4-13.7z" fill="#E5C504" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181 221.4a7.7 7.7 0 01-12-6.5c0-4.2 3.3-7.6 7.6-7.7 1.3 4.8 3 9.5 4.4 14.2z"
        fill="#C7890D"
      />
      <path
        d="M82.4 80.6C82.4 65 93.2 56 106 56c10.6 0 20 7.8 25 19.5l-4.8 2.2s-9.5-22.7-27.4-17c0 0-11.7 2.5-14 18.5l-2.4 1.4z"
        fill="#535252"
      />
      <path
        d="M105.2 22c-1-1.8-2.8-3-4.7-3.3l-2.6-.5a7 7 0 00-5.6 1.6 6.4 6.4 0 00-2.2 5.3l.2 3.3c0 .4 0 .8-.2 1.2l-.4 1c-.6 1.6-1 3-1.4 4.7l-1.2 11.4-9.5-6h-.1c-1.4-.9-3-1.4-4.6-2l-1-.2c-.4-.1-.9-.3-1.2-.8l-2.3-2a6.8 6.8 0 00-5.5-1.7c-2 .3-3.8 1.7-4.7 3.3L57 39.5c-1 1.8-1 3.9-.2 5.8a6.4 6.4 0 004.3 3.7l3.1.8c.4.2.8.3 1.2.7l.8.7c1.3 1 2.6 2 4 2.8l9.8 4a19 19 0 019.2 9.6c.7 1.3 2 4.5 2 4.5l1 2 3.1-2 9.2-5-.6-1-2-4.6c-2.3-4.9-2.8-9-1.7-13l3.2-10.1v-.2c.2-1.7.3-3.3.3-5v-1c0-.5.1-1 .3-1.3l1.3-3c1-2 .8-4.1-.1-6z"
        fill="#724010"
      />
      <path d="M137.3 102s.9 29.5-20.7 40.3l-1.3-2.8s18.9-8.6 19.3-38.8l2.7 1.2z" fill="#535252" />
      <path
        d="M112.5 148.2c4-1.4 6.3-5 5.3-7.8s-5.1-4-9.2-2.4c-4 1.5-6.4 5-5.3 7.8 1.1 2.8 5.2 3.9 9.2 2.4zM133.7 104.2c7.4 0 13.4-7 13.4-15.6 0-8.7-6-15.7-13.4-15.7-7.5 0-13.5 7-13.5 15.7 0 8.6 6 15.6 13.5 15.6z"
        fill="#535252"
      />
      <path
        d="M135.1 100.7c4.8 0 8.8-5.5 8.8-12 0-6.7-4-12-8.8-12-4.8 0-8.7 5.4-8.7 12s4 12 8.7 12z"
        fill="#848484"
      />
    </g>
  </svg>
);
